import React, { Component } from 'react';
import api from 'api';
import { Button, Tooltip, Text, Box } from 'components';
import { numberFormatter, currencyFormatter } from 'helpers';

export default class TokenTerms extends Component {
  state = {
    terms: null,
    accept_terms: false
  };

  componentDidMount() {
    api.get(`onboarding/token_terms`).then(res => {
      this.setState({ terms: res.data });
    });
  }

  handleChange = e => {
    this.setState({ accept_terms: e.target.checked });
  };

  render() {
    const { terms, accept_terms } = this.state;

    if (!terms) return null;

    const { messaging, contribution_summary } = terms;

    const disabled = !accept_terms;

    return (
      <div className="terms-overlay">
        <div id="token-terms" className="terms-modal">
          <Text display="h2" className="py-4">
            {messaging.title}
          </Text>
          <div className="row">
            <div className="col-md-4 position-relative">
              <div className="sticky">
                <Text>
                  Please check the box to acknowledge your consent.
                </Text>
                <Box mb="3">
                  <Text display="h4">
                    {numberFormatter(contribution_summary.principal_tokens)}
                  </Text>
                  <Text flex alignItems="center" display="h5">
                    Principal CRNC Tokens{' '}
                    <Tooltip text="The tokens that will be issued on the day of token issuance." />
                  </Text>
                </Box>
                <Box mb="3">
                  <Text display="h4">
                    {numberFormatter(contribution_summary.bonus_tokens)}
                  </Text>
                  <Text flex alignItems="center" display="h5">
                    Total Bonus CRNC{' '}
                    <Tooltip text="The total number of bonus tokens to be distributed, as per your agreement." />
                  </Text>
                </Box>
                <Box mb="4">
                  <Text display="h4">
                    {currencyFormatter(
                      contribution_summary.contribution_usd_equivalent
                    )}
                  </Text>
                  <Text flex alignItems="center" display="h5">
                    Pegged USD Contribution{' '}
                    <Tooltip text="The amount, in USD, of your contribution to the tokensale." />
                  </Text>
                </Box>
                <Text>
                  If there are any issues with your details, please contact us
                  at <a href="mailto:ops@current.us">ops@current.us</a>
                </Text>
              </div>
            </div>
            <div className="col-md terms-description">
              <div
                dangerouslySetInnerHTML={{ __html: messaging.description }}
              />
            </div>
          </div>
          <Box className="terms-footer terms">
            <div className="container">
              <div className="row">
                <div className="col-md d-flex">
                  <input
                    className="mt-1"
                    type="checkbox"
                    id="accept_token_terms"
                    name="accept_token_terms"
                    onChange={this.handleChange}
                  />
                  <label className="ml-3" htmlFor="accept_token_terms">
                    {messaging.accept_terms}
                  </label>
                </div>
                <div className="col-md text-right">
                  <div className="d-inline-block">
                    <Button
                      disabled={disabled}
                      secondary
                      large
                      onClick={this.props.onAccept}
                    >
                      Continue
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </div>
      </div>
    );
  }
}
